import { ISideBarItem } from './interface/main.interface';

export const AUTHERIZED_KEY = '@authenticated';
export const AUTHERIZED_USER = '@user';
export const AUTHERIZED_TOKEN = '@token';
export const AUTHERIZED_X_TOKEN = '@xtoken';
export const AUTHERIZED_TOKEN_REFRESH_TIME = '@xtoken_time';

export const __DEV__ = '';
export const BASE_URL = 'https://api.uat.classveew.com/v2';
export const MOCK_BASE_URL = ' http://3.28.240.228:4075/api/v2';
//  export const BASE_URL ='http://3.28.183.13:4001/api/v2'
// new 'http://3.28.240.228/v2/profile/student?page=5&pageSize=1
// http://3.28.240.228/api/v2

export enum COMPONENT_SIZE {
  SMALL = 'sm',
  LARGE = 'lg',
}

/*
We have defined set of constants for application response codes.
These constants are used to standardize error responses across the application.
Need to make sure if we are implementing any new codes we need to communicate
with FE team and align with them
*/
export const APP_ERROR_CODE = {
  ORGANIZATION_UNDER_REVIEW: {
    status: 'ORGANIZATION_UNDER_REVIEW',
  },
  FIRST_LOGIN_PASSWORD_CHANGE: {
    name: 'FIRST_LOGIN_PASSWORD_CHANGE_REQUIRED',
  },
};

export enum SCREEN_MODE {
  CREATE = 'create',
  EDIT = 'edit',
  VIEW = 'view',
}

export enum EXAM_STATUS {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  ARCHIVED = 'ARCHIVED',
  COMPLETED = 'COMPLETED',
}

export enum ME_TYPES {
  CLASSROOM = 'classroom',
  POST = 'post',
  TIMETABLE = 'timetable',
}
export const STATUS = {
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
};

export enum LOAN_STATUS {
  AVAILBALE = 'Active',
  ONLOAN = 'On Loan',
}

export enum LEND_TYPES {
  LEND_IN = 'Lend-In',
  LEND_OUT = 'Lend-Out',
}

export enum CIRCULATION_STATUS {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export const POST_CONFIG = {
  rowsPerPage: 10,
};

export enum APP_STATUS {
  LOADING = 'LOADING',
  IDLE = 'IDLE',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  INITIAL = 'INITIAL',
}

export enum USER_TYPE {
  ADMIN = 'Admin',
  TEACHER = 'Teacher',
  SUPER_ADMIN = 'SuperAdmin',
}

export enum FORM_VALIDATOR_TYPES {
  TEXT = 'text',
  NUMBER = 'number',
  DATE = 'date',
  OBJECT = 'object',
  ARRAY = 'array',
  EMAIL = 'email',
  FILE = 'file',
  BOOLEAN = 'Boolean',
  GOOGLE_LINK = 'google link',
  TIME = 'time',
  PHONE = 'phone', // Added phone type
  PASSWORD = 'password', // Added password type
  EMAIL_OR_CLASSVEEW_ID = 'email or classveew id', // Login identifier: staff email OR student ClassVeew ID
}

export enum APP_FEATURES {
  VIEW_DASHBOARD = 'View Dashboard',
  GRADE_MANAGEMENT = 'Grade Management',
  CLASSROOM_MANAGEMENT = 'Classroom Management',
  TEACHER_MANAGEMENT = 'Teacher Management',
  TEACHER_ASSIGNMENT_MANAGEMENT = 'Teacher Assignment Management',
  SUBJECT_MANAGEMENT = 'Subject Management',
  STUDENT_MANAGEMENT = 'Student Management',
  SYLLABUS_MANAGEMENT = 'Syllabus Management',
  ACADEMIC_YEAR_MANAGEMENT = 'Academic Year Management',
  ACADEMIC_YEAR_DELETE = 'Academic Year Deletion',
  HOLIDAY_MANAGEMENT = 'Holiday Management',
  ROLE_MANAGEMENT = 'Role Management',
  USER_MANAGEMENT = 'User Management',
  BOOK_MANAGEMENT = 'Book Management',
  BOOK_CIRCULATION = 'Book Circulation',
  EXAM_MANAGEMENT = 'Exam Management',
  // Marking (grading) an exam subject. Distinct from EXAM_MANAGEMENT: the
  // default Teacher role holds this but NOT EXAM_MANAGEMENT, which is why the
  // marking screens need their own route + sidebar entry rather than living
  // under /exam-management. String must match the backend
  // `APP_FEATURES.EXAM_MARKING` ('Exam Marking') exactly — privileges are
  // compared as raw strings against the session payload.
  EXAM_MARKING = 'Exam Marking',
  ATTENDANCE_CUTOFF_MANAGEMENT = 'Attendance Cutoff Management',
  MY_INSTITUTE = 'My Institute',
  FEE_TEMPLATE_MANAGEMENT = 'Fee Template Management',
  INVOICE_MANAGEMENT = 'Invoice Management',
  VIEW_SESSION_HISTORY = 'View Session History',
  ATTENDANCE_MARKING = 'Attendance Marking',
  MY_CLASSROOM_ATTENDANCE_MARKING = 'My Classroom Attendance Marking',
  ROSTER_MANAGEMENT = 'Roster Management',
  EVENT_MANAGEMENT = 'Event Management',
  CURRICULUM_MANAGEMENT = 'Curriculum Management',
  /** My OWN check-in/out, my own history, my own leave. Teachers hold this. */
  SELF_ATTENDANCE_LEAVE = 'My Attendance and Leave',
  /** The institute's attendance register — other people's records. Admins only. */
  STAFF_ATTENDANCE_MANAGEMENT = 'Staff Attendance Management',
  STAFF_LEAVE_MANAGEMENT = 'Staff Leave Management',
  ORGANIZATION_MANAGEMENT = 'Organization Management',
  CLASSVEEW_ORGANIZATION_MANAGEMENT = 'Classveew Organization Management',
  CLASSVEEW_STUDENT_MANAGEMENT = 'Classveew Student Management',
  CLASSVEEW_GUARDIAN_MANAGEMENT = 'Classveew Guardian Management',
  CLASSVEEW_TEACHER_MANAGEMENT = 'Classveew Teacher Management',
  CLASSVEEW_AWARD_MANAGEMENT = 'Classveew Award Management',
  RE_ENROLLMENT_MANAGEMENT = 'Re-enrollment Management',
  HOMEWORK_MANAGEMENT = 'Homework Management',
  INITIAL_SYSTEM_SETUP = 'Initial System Setup',
  REPORT_MANAGEMENT = 'Report Management',
  FINANCE_REPORT_MANAGEMENT = 'Finance Report Management',
  STUDENT_REPORT_MANAGEMENT = 'Student Report Management',
  TEACHER_REPORT_MANAGEMENT = 'Teacher Report Management',
  REVOKE_PAYMENT = 'Revoke Payment',
  CANCEL_INVOICE = 'Cancel Invoice',
  DELETE_INVOICE = 'Delete Invoice',
  STUDENT_ATTENDANCE_REPORT_MANAGEMENT = 'Student Attendance Report Management',
  CLASSVEEW_POST_MANAGEMENT = 'Classveew Post Management',
  BILLING_MANAGEMENT = 'Billing Management',
  REFUND_INVOICE = 'Refund Invoice',
  PARENT_HOMEWORK = 'Parent Homework',
  PARENT_VIEW_EXAM = 'Parent View Exam',
  // A student's own view of their exams. The shared student/guardian exam
  // endpoints accept EITHER this or PARENT_VIEW_EXAM; the server then resolves
  // whether the caller may act for that student. Must match the backend
  // APP_FEATURES value exactly — privileges compare as strings.
  STUDENT_VIEW_EXAM = 'Student View Exam',
  // CVA-4730: a child's own view of their homework. The shared
  // student/guardian homework endpoints (`v2/student/homework/...`) accept
  // this; the guardian equivalent is PARENT_HOMEWORK against
  // `v2/parent/homework/...`. Must match the backend APP_FEATURES value
  // exactly — privileges compare as strings.
  STUDENT_HOMEWORK = 'Student Homework',
  // CVA-4740: the guardian academic READ surfaces. A guardian never holds the
  // staff privilege covering the same data (ROSTER_MANAGEMENT, EVENT_*, ...),
  // so privilege filtering shows exactly one sidebar entry per audience.
  // Holding one of these still proves nothing about WHICH child — the
  // `v2/parent/*` endpoints resolve the guardian link per request. Must match
  // the backend APP_FEATURES values exactly; privileges compare as raw
  // strings against the session payload.
  //
  // Only PARENT_VIEW_TIMETABLE has a page so far; the other three are
  // declared with it because they are provisioned and seeded together on the
  // backend, and `useStudentPortalIdentity` already has to recognise all four.
  PARENT_VIEW_TIMETABLE = 'Parent View Timetable',
  PARENT_VIEW_EVENT = 'Parent View Event',
  PARENT_VIEW_SUBJECT = 'Parent View Subject',
  PARENT_VIEW_SYLLABUS = 'Parent View Syllabus',
  ORGANIZATION_CONFIGURATION_MANAGEMENT = 'Organization Configuration Management',
  // CVA-3603: platform-admin-only global discount campaign ledger. Value must
  // match the backend APP_FEATURES entry exactly ('Classveew Discount Ledger
  // View') — privileges compare as raw strings against the session payload.
  // Seeded ONLY onto the platform/landlord admin role (never
  // DEFAULT_ADMIN_ROLE) so a school's own Admin cannot see cross-institute
  // discount data.
  CLASSVEEW_DISCOUNT_LEDGER_VIEW = 'Classveew Discount Ledger View',
  // CVA-4443: gates the "+ Create Institute Discount" button specifically —
  // narrower than VIEW so a role that can see the ledger but isn't the
  // literal landlord admin doesn't see a button that would 403 on submit
  // (the backend's create endpoint is ClassveewAdminGuard-only). Must match
  // the backend APP_FEATURES entry exactly ('Classveew Discount Ledger
  // Create'). Seeded ONLY onto the platform/landlord admin role, same as VIEW.
  CLASSVEEW_DISCOUNT_LEDGER_CREATE = 'Classveew Discount Ledger Create',
}

export const APP_ROUTES = {
  FIRST_CHANGE_PASSWORD: '/first-change-password',
  // Multi-organization users pick an organization here after login
  // (temp-token flow — public branch, user is not fully authenticated yet)
  ORGANIZATION_SELECTION: '/organization-selection',
  ROOT: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  DASHBOARD: '/dashboard',
  // CVA-4718: org-scoped News Feed tab, sibling to Dashboard — distinct from
  // ADMIN_NEWS_FEED below, which is the Classveew Admin/Tenant, landlord-only
  // moderation view under /classveew/*. Do not conflate the two.
  NEWS_FEED: '/news-feed',
  STAFF: '/staff',
  FORBIDDEN: '/access-denied',
  UNAUTHORIZED: '/unauthorized',
  NOT_FOUND: '/not-found',
  WILD_CARD: '/*',
  ORG_INVALID_TOKEN: '/invalid-token',
  ORG_ALREADY_CREATED: '/onboarding/completed',

  FORGET_PASSWORD: '/forgetpassword',
  OTP_FORGET_PASSWORD: '/OtpForgetpassword',
  NEW_CREDENTIALS: '/NewCredentials',
  PASSWORD_UPDATED: '/PasswordUpdated',
  CONFIRM_OTP: '/confirmOtp',

  WELCOME_MESSAGE: '/welcomeMessage',
  CONFIRMATION: '/confirmation',
  // Common, role-neutral landing page for authenticated users with no
  // privilege-gated staff screens (Students today, Guardians later).
  HOME: '/home',

  DEMO_SHCEDULE: '/demoSchedule',
  ADMINISTRATION_DETAILS: '/adminstrationDetails',
  ONBOARDING: '/onboarding',
  SCHOOL_DETAILS: '/schoolDetails',

  STUDENT: '/student-management',
  ATTENDANCE: '/attendance',
  RE_ENROLLMENT_MANAGEMENT: '/re-enrollment-management',
  RE_ENROLLMENT_STUDENT_VIEW: '/re-enrollment-management/cycle/:cycleId/view-students',

  // Finance
  INVOICE_MANAGEMENT: '/invoice-management',
  SESSION_REQUIRED: '/session-required',
  SESSION_HISTORY: '/session-history',
  FEE_TEMPLATE: '/template-management',
  BILLING_AND_PLANS: '/billing-and-plans',

  // Staff & users
  TEACHER_MANAGEMENT: '/teacher-management',
  CREATE_TEACHER: '/teacher-management/create',
  // The tabbed profile for an existing teacher. Editing is one tab of it, so
  // the route is named for the screen rather than for that tab; EDIT_TEACHER is
  // kept only to redirect links minted before the split (CVA-1266).
  TEACHER_PROFILE: '/teacher-management/profile',
  EDIT_TEACHER: '/teacher-management/edit',

  ROLE_MANAGEMENT: '/role-management',
  CREATE_ROLE: '/role-management/create',
  EDIT_ROLE: '/role-management/edit',
  VIEW_ROLE: '/role-management/view',

  USER_MANAGEMENT: '/user-management',
  CREATE_USER: '/user-management/create',
  EDIT_USER: '/user-management/edit',

  GUARDIAN_MANAGEMENT: '/guardian-management',
  GUARDIAN_ONBOARDING: '/admin/guardian-onboarding',

  ORGANIZATION_ADMIN_MANAGEMENT: '/organization-operator-management',

  // Admin
  ADMIN_ORGANIZATIONS: '/classveew/organizations',
  ADMIN_REQUEST_ORGANIZATIONS: '/classveew/request-organizations',
  ADMIN_ORGANIZATION_CREATE: '/classveew/organizations/create',
  ADMIN_ORGANIZATION_VIEW: '/classveew/organizations/:id/view',
  ADMIN_ORGANIZATION_EDIT: '/classveew/organizations/:id/edit',
  ADMIN_STUDENTS: '/classveew/student-management',
  ADMIN_STUDENT_VIEW: '/classveew/student-management/:id/view',
  ADMIN_STUDENT_EDIT: '/classveew/student-management/:id/edit',
  ADMIN_TEACHERS: '/classveew/teacher-management',
  ADMIN_TEACHER_VIEW: '/classveew/teacher-management/:id/view',
  ADMIN_TEACHER_EDIT: '/classveew/teacher-management/:id/edit',
  ADMIN_GUARDIANS: '/classveew/guardian-management',
  ADMIN_GUARDIAN_VIEW: '/classveew/guardian-management/:id/view',
  ADMIN_GUARDIAN_EDIT: '/classveew/guardian-management/:id/edit',
  ADMIN_AWARDS: '/classveew/awards',
  ADMIN_NEWS_FEED: '/classveew/news-feed',
  // CVA-3603: global, all-institutes discount campaign ledger (read-only).
  ADMIN_DISCOUNT_LEDGER: '/classveew/discount-ledger',

  // Academic
  TIMETABLE_MANAGEMENT: '/timeTable-management',
  MANAGE_TIMETABLE: '/timeTable-management/manage',

  SYLLABUS_MANAGEMENT: '/syllabus-management',
  CREATE_SYLLABUS: '/syllabus-management/create',
  EDIT_SYLLABUS: '/syllabus-management/edit',

  EXAM_MANAGEMENT: '/exam-management',
  VIEW_EXAM: '/exam-management/view',
  EXAM_REPORT_CARD: '/exam-management/view/:examId/report-card/:studentId',
  // CVA-4197 plan 0009 — read-only paper view, reached from View Exam AND from
  // the teacher-facing marking screens below (both privileges guard this route).
  EXAM_PAPER_VIEW: '/exam-management/view/:examId/subject/:examSubjectId/paper',
  // Marking (grading) flow. Reached from Exam Management (both Teachers and
  // Admins) or View Exam's per-subject Grade button (Admins). The dormant
  // `/exam-marking` list-page route was removed 2026-09-03 (CVA-4197 plan
  // 0011 cleanup) — nothing links to it anymore.
  EXAM_SUBJECT_MARKING: '/exam-marking/:examId/subject/:examSubjectId',
  // CVA-4197 plan 0011 slice 4 — the Flow A canvas (per-question grading for
  // one student). ONLINE subjects reach this via EXAM_SUBJECT_MARKING's row
  // icon (slice 7); OFFLINE subjects still open MarkStudentModal there.
  EXAM_ATTEMPT_MARKING: '/exam-marking/:examId/subject/:examSubjectId/student/:studentId',
  HOMEWORK_MANAGEMENT: '/homework-management',
  CREATE_HOMEWORK: '/homework-management/create',
  EDIT_HOMEWORK: '/homework-management/:homeworkId/edit',
  VIEW_HOMEWORK: '/homework-management/:homeworkId/view',
  HOMEWORK_TASK_GRADING: '/homework-management/:homeworkId/grading/:detailId',

  // Parent (guardian) flow — child context comes from the sidebar student selector
  PARENT_HOMEWORK_MANAGEMENT: '/parent/homework',
  PARENT_VIEW_HOMEWORK: '/parent/homework/view/:homeworkId',
  // CVA-4740 — read-only view of the timetable of the classroom the selected
  // child is assigned to. No /student/ mirror yet; CVA-4733 adds the child's.
  PARENT_TIMETABLE: '/parent/timetable',
  // CVA-4740 — read-only list/calendar of the selected child's events.
  PARENT_EVENTS: '/parent/events',
  // CVA-4740 — the child's subjects; the syllabus opens from a row action
  // rather than a page of its own.
  PARENT_SUBJECTS: '/parent/subjects',
  // CVA-4197 join-exam: the retired /parent/exams routes and their page
  // cluster were removed 2026-08-17 — guardians route through STUDENT_EXAMS*
  // below (dual-privilege, shared with students). See
  // parent-guardian-exam-flow.adoc's "Historical record" section.
  STUDENT_EXAMS: '/student/exams',
  STUDENT_EXAM_DETAIL: '/student/exams/:examId',
  STUDENT_EXAM_REPORT_CARD: '/student/exams/:examId/report-card',
  // CVA-4197 join-exam plan 0004: dual-privilege by design (STUDENT_VIEW_EXAM
  // OR PARENT_VIEW_EXAM) — a guardian reaches this same URL, no /parent/
  // mirror route. Chromeless: rendered outside MainLayout (<<chromeless>>).
  STUDENT_EXAM_ATTEMPT: '/student/exams/:examId/subject/:examSubjectId/attempt',
  // CVA-4730 "one flow, two audiences" for homework: these render the SAME
  // pages the guardian /parent/homework routes render. A child never visits
  // the /parent/ URLs (their privilege doesn't allow it) and a guardian never
  // visits these — the sidebar gives each audience only its own pair.
  STUDENT_HOMEWORK: '/student/homework',
  STUDENT_VIEW_HOMEWORK: '/student/homework/view/:homeworkId',

  ASSIGN_CLASSROOMS: '/assign-classrooms',

  // Library
  BOOK_MANAGEMENT: '/book-management',
  BOOK_CIRCULATION: '/book-circulation',

  // MASTER DATA
  OPERATIONAL_TIME_SETTINGS: '/operational-time-settings',
  CURRICULUM_MANAGEMENT: '/curriculum-management',
  ACADEMIC_YEAR_MANAGEMENT: '/academic-year-management',
  GRADE_MANAGEMENT: '/grade-management',
  CLASSROOM_MANAGEMENT: '/classroom-management',
  SUBJECT_MANAGEMENT: '/subject-management',
  SUBJECT_ASSIGN: '/subject-management/assignment',
  MY_INSTITUTE: '/my-institute',
  // CVA-3753: personal profile + security settings. Reachable by every
  // authenticated user; the institute tab inside it is privilege gated.
  MY_PROFILE: '/my-profile',
  // CVA-3748: two-factor OTP entry, reached mid-login with a scoped token.
  TWO_FACTOR_VERIFICATION: '/two-factor-verification',

  // Communication
  EVENT_MANAGEMENT: '/event-management',
  CREATE_EVENT: '/event-management/create',
  VIEW_EVENT_CONSENT: '/event-management/consent',

  // Change Password
  CHANGE_PASSWORD: '/change-password',

  // Teacher Attendance
  TEACHER_ATTENDANCE: '/teacher-attendance',

  // CVA-4451: staff leave. One route for both audiences — an approver sees the
  // whole institute, a teacher sees their own requests.
  STAFF_LEAVE: '/staff-leave',
  /**
   * CVA-417 note: correction requests have NO route of their own. They are the
   * second tab of Teacher Attendance, because an admin fixing someone's day and
   * an admin reading the request that prompted it are the same task.
   */
  /** The reader's OWN leave. Personal, so it lives under Profile in the nav. */
  MY_LEAVE: '/my-leave',

  // ETL Dashboard (Initial System Setup)
  ETL_DASHBOARD: '/etl-dashboard',

  // ETL Quick Setup (Template Selection — CVA-3416)
  ETL_QUICK_SETUP: '/etl-quick-setup',

  // ETL Quick Setup Review/Confirm — CVA-3417
  ETL_QUICK_SETUP_REVIEW: '/etl-quick-setup/review',

  // Reports
  REPORTS: '/reports',
  REPORTS_FINANCE: '/reports/finance',
  REPORTS_STUDENT: '/reports/students',
  REPORTS_TEACHER: '/reports/teachers',
  REPORTS_STUDENT_ATTENDANCE: '/reports/student-attendance',

  // AI Marketing Agent
  CLASSVEEW_AI: '/classveew-ai',
};

/**
 * Routes accessible when organization is restricted due to unpaid invoices
 * Used by SubscriptionGuard and SideMenu for access control
 */
export const RESTRICTED_ALLOWED_ROUTES = [
  APP_ROUTES.BILLING_AND_PLANS,
  APP_ROUTES.CHANGE_PASSWORD,
  APP_ROUTES.FORBIDDEN, // Non-billing users land here when org is restricted
];

// Common UI strings for empty lists and CTAs
export const DROPDOWN_EMPTY_LIST = {
  DEFAULT_MESSAGE: "You don't have any options yet.",
  DEFAULT_CTA: 'Create new',
};

export const SIDE_BAR_ITEMS: ISideBarItem[] = [
  {
    label: 'Dashboard',
    icon: 'DashBoardIcon',
    privileges: [APP_FEATURES.VIEW_DASHBOARD],
    route: APP_ROUTES.DASHBOARD,
    isShown: true,
  },
  {
    label: 'News Feed',
    icon: 'newsFeedIcon',
    route: APP_ROUTES.ADMIN_NEWS_FEED,
    privileges: [APP_FEATURES.CLASSVEEW_POST_MANAGEMENT],
    isShown: true,
  },
  // CVA-4718: separate, org-scoped News Feed entry — NOT the Classveew Admin
  // entry above. Gated by VIEW_DASHBOARD (same permission as Dashboard,
  // per the backend implementation plan's recommendation) so both entries
  // stay independently visible/hidden based on their own privilege.
  {
    label: 'News Feed',
    icon: 'newsFeedIcon',
    route: APP_ROUTES.NEWS_FEED,
    privileges: [APP_FEATURES.VIEW_DASHBOARD],
    isShown: true,
  },
  {
    label: 'Organization Management',
    icon: 'classveewOrgMgtIcon',
    route: '',
    privileges: [APP_FEATURES.CLASSVEEW_ORGANIZATION_MANAGEMENT],
    isShown: true,
    children: [
      {
        label: 'Approved Organization',
        route: APP_ROUTES.ADMIN_ORGANIZATIONS,
        privileges: [APP_FEATURES.CLASSVEEW_ORGANIZATION_MANAGEMENT],
        isShown: true,
      },
      {
        label: 'Request Organization',
        route: APP_ROUTES.ADMIN_REQUEST_ORGANIZATIONS,
        privileges: [APP_FEATURES.CLASSVEEW_ORGANIZATION_MANAGEMENT],
        isShown: true,
      },
      {
        label: 'Organization Management - Create',
        icon: 'classveewOrgMgtIcon',
        route: APP_ROUTES.ADMIN_ORGANIZATION_CREATE,
        privileges: [APP_FEATURES.CLASSVEEW_ORGANIZATION_MANAGEMENT],
        isShown: false,
      },
      {
        label: 'Organization Management - View',
        icon: 'classveewOrgMgtIcon',
        route: APP_ROUTES.ADMIN_ORGANIZATION_VIEW,
        privileges: [APP_FEATURES.CLASSVEEW_ORGANIZATION_MANAGEMENT],
        isShown: false,
      },
      {
        label: 'Organization Management - Edit',
        icon: 'classveewOrgMgtIcon',
        route: APP_ROUTES.ADMIN_ORGANIZATION_EDIT,
        privileges: [APP_FEATURES.CLASSVEEW_ORGANIZATION_MANAGEMENT],
        isShown: false,
      },
    ],
  },
  {
    label: 'Student Management',
    icon: 'studentManagementIcon',
    route: APP_ROUTES.ADMIN_STUDENTS,
    privileges: [APP_FEATURES.CLASSVEEW_STUDENT_MANAGEMENT],
    isShown: true,
    children: [
      {
        label: 'Student Management - View',
        icon: 'studentManagementIcon',
        route: APP_ROUTES.ADMIN_STUDENT_VIEW,
        privileges: [APP_FEATURES.CLASSVEEW_STUDENT_MANAGEMENT],
        isShown: false,
      },
      {
        label: 'Student Management - Edit',
        icon: 'studentManagementIcon',
        route: APP_ROUTES.ADMIN_STUDENT_EDIT,
        privileges: [APP_FEATURES.CLASSVEEW_STUDENT_MANAGEMENT],
        isShown: false,
      },
    ],
  },
  {
    label: 'Teacher Management',
    icon: 'teacherManagementIcon',
    route: APP_ROUTES.ADMIN_TEACHERS,
    privileges: [APP_FEATURES.CLASSVEEW_TEACHER_MANAGEMENT],
    isShown: true,
    children: [
      {
        label: 'Teacher Management - View',
        icon: 'teacherManagementIcon',
        route: APP_ROUTES.ADMIN_TEACHER_VIEW,
        privileges: [APP_FEATURES.CLASSVEEW_TEACHER_MANAGEMENT],
        isShown: false,
      },
      {
        label: 'Teacher Management - Edit',
        icon: 'teacherManagementIcon',
        route: APP_ROUTES.ADMIN_TEACHER_EDIT,
        privileges: [APP_FEATURES.CLASSVEEW_TEACHER_MANAGEMENT],
        isShown: false,
      },
    ],
  },
  {
    label: 'Guardian Management',
    icon: 'ManageIcon',
    route: APP_ROUTES.ADMIN_GUARDIANS,
    privileges: [APP_FEATURES.CLASSVEEW_GUARDIAN_MANAGEMENT],
    isShown: true,
    children: [
      {
        label: 'Guardian Management - View',
        icon: 'ManageIcon',
        route: APP_ROUTES.ADMIN_GUARDIAN_VIEW,
        privileges: [APP_FEATURES.CLASSVEEW_GUARDIAN_MANAGEMENT],
        isShown: false,
      },
      {
        label: 'Guardian Management - Edit',
        icon: 'ManageIcon',
        route: APP_ROUTES.ADMIN_GUARDIAN_EDIT,
        privileges: [APP_FEATURES.CLASSVEEW_GUARDIAN_MANAGEMENT],
        isShown: false,
      },
    ],
  },
  {
    label: 'Award Management',
    icon: 'MasterDataIcon',
    route: APP_ROUTES.ADMIN_AWARDS,
    privileges: [APP_FEATURES.CLASSVEEW_AWARD_MANAGEMENT],
    isShown: true,
  },
  {
    // CVA-3603: platform-admin-only, all-institutes discount campaign ledger.
    label: 'Discount Ledger',
    icon: 'BillingIcon',
    route: APP_ROUTES.ADMIN_DISCOUNT_LEDGER,
    privileges: [APP_FEATURES.CLASSVEEW_DISCOUNT_LEDGER_VIEW],
    isShown: true,
  },
  {
    label: 'Students',
    icon: 'ManageIcon',
    route: '',
    children: [
      {
        label: 'Student Management',
        route: APP_ROUTES.STUDENT,
        privileges: [APP_FEATURES.STUDENT_MANAGEMENT],
        isShown: true,
        children: [
          {
            label: 'Student Management - Edit',
            route: `${APP_ROUTES.STUDENT}/:id/edit`,
            privileges: [APP_FEATURES.STUDENT_MANAGEMENT],
            isShown: false,
          },
          {
            label: 'Student Management - View',
            route: `${APP_ROUTES.STUDENT}/:id/view`,
            privileges: [APP_FEATURES.STUDENT_MANAGEMENT],
            isShown: false,
          },
        ],
      },
      {
        label: 'Attendance Tracking',
        route: APP_ROUTES.ATTENDANCE,
        privileges: [APP_FEATURES.ATTENDANCE_MARKING, APP_FEATURES.MY_CLASSROOM_ATTENDANCE_MARKING],
        isShown: true,
      },
      {
        label: 'Re-enrollment Management',
        route: APP_ROUTES.RE_ENROLLMENT_MANAGEMENT,
        privileges: [APP_FEATURES.RE_ENROLLMENT_MANAGEMENT],
        isShown: true,
        subscriptionFeature: 'can_manage_reenrolment',
        children: [
          {
            label: 'Student Re-enrollment - View',
            route: APP_ROUTES.RE_ENROLLMENT_STUDENT_VIEW,
            privileges: [APP_FEATURES.RE_ENROLLMENT_MANAGEMENT],
            isShown: false,
          },
        ],
      },
    ],
  },
  {
    label: 'Finance',
    icon: 'financeIcon', // Replace with actual icon import
    route: '',
    subscriptionFeature: 'fee_management',
    children: [
      {
        label: 'Invoice Management',
        route: APP_ROUTES.INVOICE_MANAGEMENT,
        privileges: [APP_FEATURES.INVOICE_MANAGEMENT],
        isShown: true,
      },
      {
        label: 'Cashier Sessions',
        route: APP_ROUTES.SESSION_HISTORY,
        privileges: [APP_FEATURES.VIEW_SESSION_HISTORY],
        isShown: true,
      },
      {
        label: 'Template Management',
        route: APP_ROUTES.FEE_TEMPLATE,
        privileges: [APP_FEATURES.FEE_TEMPLATE_MANAGEMENT],
        isShown: true,
      },
    ],
  },
  {
    label: 'Staff & Users',
    icon: 'staffUsersIcon', // Replace with actual icon import
    route: '',
    children: [
      {
        label: 'Teacher Management',
        route: APP_ROUTES.TEACHER_MANAGEMENT,
        privileges: [APP_FEATURES.TEACHER_MANAGEMENT],
        isShown: true,
        children: [
          {
            label: 'Create Teacher',
            route: APP_ROUTES.CREATE_TEACHER,
            privileges: [APP_FEATURES.TEACHER_MANAGEMENT],
            isShown: false,
          },
          {
            label: 'Teacher Profile',
            route: `${APP_ROUTES.TEACHER_PROFILE}/:id`,
            privileges: [APP_FEATURES.TEACHER_MANAGEMENT],
            isShown: false,
          },
        ],
      },
      {
        // The institute's register, not the reader's own attendance. It was
        // gated on the self-service privilege, which every teacher holds — so
        // teachers saw
        // (and could open) the whole institute's attendance.
        label: 'Teacher Attendance',
        route: APP_ROUTES.TEACHER_ATTENDANCE,
        privileges: [APP_FEATURES.STAFF_ATTENDANCE_MANAGEMENT],
        isShown: true,
        subscriptionFeature: 'has_teacher_attendance',
        children: [],
      },
      {
        // The institute's approval queue — other people's leave. A teacher's own
        // requests are NOT here: they live under Profile → My Leave, because
        // Staff & Users is where you manage other people. Accepting the
        // self-service privilege here put a management group in a teacher's nav
        // containing nothing but their own leave.
        label: 'Staff Leaves',
        route: APP_ROUTES.STAFF_LEAVE,
        privileges: [APP_FEATURES.STAFF_LEAVE_MANAGEMENT],
        isShown: true,
        subscriptionFeature: 'has_teacher_attendance',
        children: [],
      },
      {
        label: 'Role Management',
        route: APP_ROUTES.ROLE_MANAGEMENT,
        privileges: [APP_FEATURES.ROLE_MANAGEMENT],
        isShown: true,
        children: [
          {
            label: 'Create Role',
            route: APP_ROUTES.CREATE_ROLE,
            privileges: [APP_FEATURES.ROLE_MANAGEMENT],
            isShown: false,
          },
          {
            label: 'Edit Role',
            route: `${APP_ROUTES.EDIT_ROLE}/:id`,
            privileges: [APP_FEATURES.ROLE_MANAGEMENT],
            isShown: false,
          },
        ],
      },
      {
        label: 'Guardian Management',
        route: APP_ROUTES.GUARDIAN_MANAGEMENT,
        privileges: [APP_FEATURES.USER_MANAGEMENT],
        isShown: true,
        children: [],
      },
      {
        label: 'Admin Management',
        route: APP_ROUTES.ORGANIZATION_ADMIN_MANAGEMENT,
        privileges: [APP_FEATURES.USER_MANAGEMENT],
        isShown: true,
        children: [],
      },
      {
        label: 'User Management',
        route: APP_ROUTES.USER_MANAGEMENT,
        privileges: [APP_FEATURES.USER_MANAGEMENT],
        isShown: true,
        children: [
          {
            label: 'Create User',
            route: APP_ROUTES.CREATE_USER,
            privileges: [APP_FEATURES.USER_MANAGEMENT],
            isShown: false,
          },
          {
            label: 'Edit User',
            route: `${APP_ROUTES.EDIT_USER}/:id`,
            privileges: [APP_FEATURES.USER_MANAGEMENT],
            isShown: false,
          },
        ],
      },
    ],
  },
  {
    label: 'Communication',
    icon: 'communicationIcon',
    route: '',
    children: [
      {
        label: 'Event Management',
        route: APP_ROUTES.EVENT_MANAGEMENT,
        privileges: [APP_FEATURES.EVENT_MANAGEMENT],
        isShown: true,
        subscriptionFeature: 'event_creation_level',
        children: [
          {
            label: 'Create Event',
            route: `${APP_ROUTES.CREATE_EVENT}`,
            privileges: [APP_FEATURES.EVENT_MANAGEMENT],
            isShown: false,
          },
          {
            label: 'Edit Event',
            route: `${APP_ROUTES.EVENT_MANAGEMENT}/:id/${SCREEN_MODE.EDIT}`,
            privileges: [APP_FEATURES.EVENT_MANAGEMENT],
            isShown: false,
          },
          {
            label: 'View Event',
            route: `${APP_ROUTES.EVENT_MANAGEMENT}/:id/${SCREEN_MODE.VIEW}`,
            privileges: [APP_FEATURES.EVENT_MANAGEMENT],
            isShown: false,
          },
          {
            label: 'View Event Consent Details',
            route: `${APP_ROUTES.VIEW_EVENT_CONSENT}/:id`,
            privileges: [APP_FEATURES.EVENT_MANAGEMENT],
            isShown: false,
          },
        ],
      },
    ],
  },
  {
    // CVA-4740 — guardian events. Its own top-level item, NOT a child of
    // Academic: an event is a school-life notice (trips, concerts, meetings),
    // not coursework, and the staff equivalent lives under Communication
    // rather than Academic for the same reason. Placed here so it keeps that
    // same position relative to Academic that staff see.
    //
    // Guardians hold 'Parent View Event' and staff hold 'Event Management',
    // so privilege filtering shows exactly one events destination per user.
    // No `subscriptionFeature` key, matching the other guardian entries: a
    // guardian has other destinations, so the item stays visible and routes
    // to FeatureBlockedPage when the plan lacks the Events feature.
    label: 'Events',
    icon: 'pi pi-calendar',
    route: APP_ROUTES.PARENT_EVENTS,
    privileges: [APP_FEATURES.PARENT_VIEW_EVENT],
    isShown: true,
  },
  {
    label: 'Academic',
    icon: 'academicIcon',
    route: '',
    children: [
      {
        label: 'Timetable Management',
        route: APP_ROUTES.TIMETABLE_MANAGEMENT,
        privileges: [APP_FEATURES.ROSTER_MANAGEMENT],
        isShown: true,
        subscriptionFeature: 'can_manage_timetable',
        children: [
          {
            label: 'Manage Timetable',
            route: `${APP_ROUTES.MANAGE_TIMETABLE}/:id`,
            privileges: [APP_FEATURES.ROSTER_MANAGEMENT],
            isShown: false,
          },
        ],
      },
      {
        label: 'Exam Management',
        route: APP_ROUTES.EXAM_MANAGEMENT,
        // Widened so a Teacher holding only EXAM_MARKING (invigilator or
        // marking teacher on at least one subject) reaches the same shared
        // screens Admin uses, scoped down server-side — no separate sidebar
        // entry, no excludePrivileges mechanism (see CVA-4197 plan 0009's
        // sidebar-fix note: that approach was tried and explicitly reverted).
        //
        // CVA-4666: NOT filtered by `subscriptionFeature` — staff have other
        // destinations, so the entry stays visible and routes to
        // FeatureBlockedPage via SubscriptionFeatureGuard when the plan
        // (e.g. Basic) doesn't include exam_management. Same reasoning as
        // Homework Management below.
        privileges: [APP_FEATURES.EXAM_MANAGEMENT, APP_FEATURES.EXAM_MARKING],
        isShown: true,
        children: [
          {
            label: 'Exam Details',
            route: `${APP_ROUTES.VIEW_EXAM}/:id`,
            privileges: [APP_FEATURES.EXAM_MANAGEMENT],
            isShown: false,
          },
          {
            label: 'Report Card',
            route: APP_ROUTES.EXAM_REPORT_CARD,
            privileges: [APP_FEATURES.EXAM_MANAGEMENT, APP_FEATURES.EXAM_MARKING],
            isShown: false,
          },
          {
            // CVA-4197 plan 0009 — reached from View Exam (admin) and from
            // the teacher-facing marking screens; not a nav destination.
            label: 'View Exam Paper',
            route: APP_ROUTES.EXAM_PAPER_VIEW,
            privileges: [APP_FEATURES.EXAM_MANAGEMENT, APP_FEATURES.EXAM_MARKING],
            isShown: false,
          },
        ],
      },
      {
        // Parent (guardian) exam list — guardians hold the 'Parent View Exam'
        // privilege; staff don't, so privilege filtering hides one of the two
        // exam entries per user (no duplication).
        //
        // CVA-4197 join-exam "one flow, two audiences": routes to the SAME
        // /student/exams surface a student uses (dual-privilege route, see
        // AppRouter.lazy.tsx), not the retired exam-level-only /parent/exams
        // page — that page had no subject/Join awareness at all, so a
        // guardian had no way to reach the Join-Exam flow from the sidebar.
        // CVA-4666: NOT filtered by `subscriptionFeature` — a guardian has
        // other destinations (fees, homework, etc.), so the entry stays
        // visible and routes to FeatureBlockedPage via
        // SubscriptionFeatureGuard when the plan doesn't include
        // exam_management. (The student-only "Exams" entry below is the
        // deliberate exception to this — see its comment.)
        label: 'Exam',
        route: APP_ROUTES.STUDENT_EXAMS,
        privileges: [APP_FEATURES.PARENT_VIEW_EXAM],
        isShown: true,
        children: [
          {
            label: 'Report Card',
            route: APP_ROUTES.STUDENT_EXAM_REPORT_CARD,
            privileges: [APP_FEATURES.PARENT_VIEW_EXAM],
            isShown: false,
          },
        ],
      },
      {
        // Student's own exam list. Students hold 'Student View Exam' and neither
        // 'Parent View Exam' nor 'Exam Management', so privilege filtering shows
        // exactly one exam entry per user — same mechanism that separates the
        // parent and staff entries above.
        //
        // Filtered by `subscriptionFeature` unlike Homework Management below: a
        // student has no other destination, so leaving the entry visible would
        // make a lock screen their only reachable page.
        label: 'Exams',
        route: APP_ROUTES.STUDENT_EXAMS,
        privileges: [APP_FEATURES.STUDENT_VIEW_EXAM],
        isShown: true,
        subscriptionFeature: 'exam_management',
        children: [
          {
            label: 'Report Card',
            route: APP_ROUTES.STUDENT_EXAM_REPORT_CARD,
            privileges: [APP_FEATURES.STUDENT_VIEW_EXAM],
            isShown: false,
          },
        ],
      },
      {
        // Deliberately NOT filtered by `subscriptionFeature` — an unsubscribed
        // school keeps the entry and lands on FeatureBlockedPage instead. Hiding
        // it left users with no signal the module exists behind an upgrade.
        label: 'Homework Management',
        route: APP_ROUTES.HOMEWORK_MANAGEMENT,
        privileges: [APP_FEATURES.HOMEWORK_MANAGEMENT],
        isShown: true,
        children: [
          {
            label: 'Create Homework',
            route: APP_ROUTES.CREATE_HOMEWORK,
            privileges: [APP_FEATURES.HOMEWORK_MANAGEMENT],
            isShown: false,
          },
        ],
      },
      {
        // Parent (guardian) homework list — guardians hold the 'Parent Homework'
        // privilege; staff don't, so privilege filtering hides one of the two
        // homework entries per user (no duplication).
        label: 'Homework',
        route: APP_ROUTES.PARENT_HOMEWORK_MANAGEMENT,
        privileges: [APP_FEATURES.PARENT_HOMEWORK],
        isShown: true,
        children: [
          {
            label: 'View Homework',
            route: APP_ROUTES.PARENT_VIEW_HOMEWORK,
            privileges: [APP_FEATURES.PARENT_HOMEWORK],
            isShown: false,
          },
        ],
      },
      {
        // CVA-4740 — guardian timetable. Guardians hold 'Parent View
        // Timetable' and staff don't, so privilege filtering shows exactly one
        // timetable entry per user (no duplication with the staff entry).
        //
        // Ordered LAST of the three guardian entries on purpose: the guardian
        // group reads Exam -> Homework -> Timetable, which is the order asked
        // for on CVA-4740. Array order is what the sidebar renders, and the
        // staff/student entries interleaved around these are filtered out for
        // a guardian, so only the relative order of these three matters.
        //
        // Deliberately NOT filtered by `subscriptionFeature`, matching the
        // guardian Homework and Exam entries: a guardian has other
        // destinations, so the entry stays visible and routes to
        // FeatureBlockedPage via SubscriptionFeatureGuard when the plan does
        // not include can_manage_timetable. (The student-only entries are the
        // deliberate exception — a student would otherwise have a lock screen
        // as their only reachable page.)
        label: 'Timetable',
        route: APP_ROUTES.PARENT_TIMETABLE,
        privileges: [APP_FEATURES.PARENT_VIEW_TIMETABLE],
        isShown: true,
      },
      {
        // CVA-4740 — the child's subjects, with the syllabus behind a row
        // action. There is deliberately NO separate Syllabus entry: a
        // syllabus only means anything in the context of its subject.
        //
        // Gated on PARENT_VIEW_SUBJECT alone. A guardian without
        // PARENT_VIEW_SYLLABUS still gets the subject list; the page hides
        // the row action rather than offering one that would 403.
        label: 'Subjects',
        route: APP_ROUTES.PARENT_SUBJECTS,
        privileges: [APP_FEATURES.PARENT_VIEW_SUBJECT],
        isShown: true,
      },
      {
        // CVA-4730 — a child's own homework list. Students hold 'Student
        // Homework' and guardians hold 'Parent Homework', so privilege
        // filtering shows exactly one homework entry per user, the same
        // mechanism that separates the guardian and staff entries above.
        //
        // Deliberately NOT filtered by `subscriptionFeature` — same reasoning
        // as the guardian "Homework Management" entry: the user keeps the
        // entry and lands on FeatureBlockedPage via SubscriptionFeatureGuard
        // when the plan lacks has_homework_module. This does NOT follow the
        // student "Exams" entry's exception, because that exception exists
        // only because an exam-only student would have a lock screen as their
        // single destination — a child holding Student Homework already has
        // their own Exams entry, so a lock screen is never their only
        // reachable page.
        label: 'Homework',
        route: APP_ROUTES.STUDENT_HOMEWORK,
        privileges: [APP_FEATURES.STUDENT_HOMEWORK],
        isShown: true,
        children: [
          {
            label: 'View Homework',
            route: APP_ROUTES.STUDENT_VIEW_HOMEWORK,
            privileges: [APP_FEATURES.STUDENT_HOMEWORK],
            isShown: false,
          },
        ],
      },
      {
        label: 'Classroom Assignment',
        route: APP_ROUTES.ASSIGN_CLASSROOMS,
        privileges: [APP_FEATURES.TEACHER_ASSIGNMENT_MANAGEMENT],
        isShown: true,
      },
      {
        label: 'Subject Assignment',
        route: APP_ROUTES.SUBJECT_ASSIGN,
        privileges: [APP_FEATURES.SUBJECT_MANAGEMENT],
        isShown: true,
      },
    ],
  },
  {
    // CVA-4666: NOT filtered by `subscriptionFeature` at the group level —
    // the module stays visible in the nav and routes to FeatureBlockedPage
    // via SubscriptionFeatureGuard when the plan doesn't include
    // library_management. Same reasoning as Homework Management / Exam
    // Management above.
    label: 'Library',
    icon: 'libraryIcon', // Replace with actual icon import
    route: '',
    children: [
      {
        label: 'Book Management',
        route: APP_ROUTES.BOOK_MANAGEMENT,
        privileges: [APP_FEATURES.BOOK_MANAGEMENT],
        isShown: true,
      },
      {
        label: 'Book Circulation',
        route: APP_ROUTES.BOOK_CIRCULATION,
        privileges: [APP_FEATURES.BOOK_CIRCULATION],
        isShown: true,
      },
    ],
  },
  {
    label: 'Master Data',
    icon: 'MasterDataIcon',
    route: '',
    children: [
      {
        label: 'Curriculum Management',
        route: APP_ROUTES.CURRICULUM_MANAGEMENT,
        privileges: [APP_FEATURES.CURRICULUM_MANAGEMENT],
        isShown: true,
        subscriptionFeature: 'can_manage_academics',
      },
      {
        label: 'Academic Year Management',
        route: APP_ROUTES.ACADEMIC_YEAR_MANAGEMENT,
        privileges: [APP_FEATURES.ACADEMIC_YEAR_MANAGEMENT],
        isShown: true,
        subscriptionFeature: 'academic_year',
      },
      {
        label: 'Operational Time Settings',
        route: APP_ROUTES.OPERATIONAL_TIME_SETTINGS,
        privileges: [APP_FEATURES.ATTENDANCE_CUTOFF_MANAGEMENT],
        isShown: true,
      },

      {
        label: 'Grade Management',
        route: APP_ROUTES.GRADE_MANAGEMENT,
        privileges: [APP_FEATURES.GRADE_MANAGEMENT],
        isShown: true,
        subscriptionFeature: 'can_manage_academics',
      },
      {
        label: 'Classroom Management',
        route: APP_ROUTES.CLASSROOM_MANAGEMENT,
        privileges: [APP_FEATURES.CLASSROOM_MANAGEMENT],
        isShown: true,
      },
      {
        label: 'Subject Management',
        route: APP_ROUTES.SUBJECT_MANAGEMENT,
        privileges: [APP_FEATURES.SUBJECT_MANAGEMENT],
        isShown: true,
      },
      {
        label: 'Syllabus Management',
        route: APP_ROUTES.SYLLABUS_MANAGEMENT,
        privileges: [APP_FEATURES.SYLLABUS_MANAGEMENT],
        isShown: true,
        subscriptionFeature: 'can_manage_syllabus',
        children: [
          {
            label: 'Create Syllabus',
            route: `${APP_ROUTES.CREATE_SYLLABUS}`,
            privileges: [APP_FEATURES.SYLLABUS_MANAGEMENT],
            isShown: false,
          },
          {
            label: 'Edit Syllabus',
            route: `${APP_ROUTES.EDIT_SYLLABUS}/:id`,
            privileges: [APP_FEATURES.SYLLABUS_MANAGEMENT],
            isShown: false,
          },
        ],
      },
    ],
  },
  {
    label: 'Billing & Plans',
    icon: 'BillingIcon',
    route: APP_ROUTES.BILLING_AND_PLANS,
    privileges: [APP_FEATURES.BILLING_MANAGEMENT],
    isShown: true,
  },
  {
    // Institute details + institute-wide configuration. This sat under the
    // bottom "Profile" group between 2026-08-03 and today, which put a
    // whole-organization screen inside a personal-account group. Every other
    // org-level screen an admin manages lives in the main nav, and this is one
    // of them — it describes the institute, not the signed-in person.
    label: 'My Institute',
    icon: 'myInstituteIcon',
    route: APP_ROUTES.MY_INSTITUTE,
    privileges: [APP_FEATURES.ORGANIZATION_MANAGEMENT],
    isShown: true,
  },
  {
    label: 'Reports',
    icon: 'reportIcon',
    route: APP_ROUTES.REPORTS,
    privileges: [APP_FEATURES.REPORT_MANAGEMENT],
    isShown: true,
    subscriptionFeature: 'analytics_dashboard',
    children: [
      {
        label: 'Finance Report',
        route: APP_ROUTES.REPORTS_FINANCE,
        privileges: [APP_FEATURES.FINANCE_REPORT_MANAGEMENT],
        isShown: false,
      },
      {
        label: 'Student Report',
        route: APP_ROUTES.REPORTS_STUDENT,
        privileges: [APP_FEATURES.STUDENT_REPORT_MANAGEMENT],
        isShown: false,
      },
      {
        label: 'Teacher Report',
        route: APP_ROUTES.REPORTS_TEACHER,
        privileges: [APP_FEATURES.TEACHER_REPORT_MANAGEMENT],
        isShown: false,
      },
      {
        label: 'Student Attendance Report',
        route: APP_ROUTES.REPORTS_STUDENT_ATTENDANCE,
        privileges: [APP_FEATURES.STUDENT_ATTENDANCE_REPORT_MANAGEMENT],
        isShown: false,
      },
    ],
  },
  {
    label: 'ETL Dashboard',
    icon: 'etlSetupIcon',
    route: APP_ROUTES.ETL_DASHBOARD,
    privileges: [APP_FEATURES.INITIAL_SYSTEM_SETUP],
    isShown: true,
  },
  {
    label: 'Quick Setup: Select Curriculum',
    route: APP_ROUTES.ETL_QUICK_SETUP,
    privileges: [APP_FEATURES.INITIAL_SYSTEM_SETUP],
    isShown: false,
  },
  {
    label: 'Quick Setup: Review Summary',
    route: APP_ROUTES.ETL_QUICK_SETUP_REVIEW,
    privileges: [APP_FEATURES.INITIAL_SYSTEM_SETUP],
    isShown: false,
  },
  // {
  //   label: 'Classveew AI',
  //   icon: 'pi pi-sparkles',
  //   route: APP_ROUTES.CLASSVEEW_AI,
  //   isShown: true,
  // },

  {
    label: 'Change Password',
    icon: 'changePasswordIcon',
    route: APP_ROUTES.CHANGE_PASSWORD,
    isShown: false,
  },
];

/**
 * Sidebar items displayed during Initial System Setup
 * SuperAdmin users with only INITIAL_SYSTEM_SETUP privilege see these items
 * All items route to ETL_DASHBOARD where initial configuration is performed
 */
export const INITIAL_SYSTEM_SETUP_SIDEBAR_ITEMS: ISideBarItem[] = [
  {
    label: 'Dashboard',
    icon: 'DashBoardIcon',
    route: APP_ROUTES.ETL_DASHBOARD,
    privileges: [APP_FEATURES.INITIAL_SYSTEM_SETUP],
    isShown: true,
  },
  {
    label: 'My Institute',
    icon: 'myInstituteIcon',
    route: APP_ROUTES.ETL_DASHBOARD,
    privileges: [APP_FEATURES.INITIAL_SYSTEM_SETUP],
    isShown: true,
  },
  {
    label: 'Students',
    icon: 'ManageIcon',
    route: APP_ROUTES.ETL_DASHBOARD,
    privileges: [APP_FEATURES.INITIAL_SYSTEM_SETUP],
    isShown: true,
  },
  {
    label: 'Finance',
    icon: 'financeIcon',
    route: APP_ROUTES.ETL_DASHBOARD,
    privileges: [APP_FEATURES.INITIAL_SYSTEM_SETUP],
    isShown: true,
  },
  {
    label: 'Staff & Users',
    icon: 'staffUsersIcon',
    route: APP_ROUTES.ETL_DASHBOARD,
    privileges: [APP_FEATURES.INITIAL_SYSTEM_SETUP],
    isShown: true,
  },
  {
    label: 'Communication',
    icon: 'communicationIcon',
    route: APP_ROUTES.ETL_DASHBOARD,
    privileges: [APP_FEATURES.INITIAL_SYSTEM_SETUP],
    isShown: true,
  },
  {
    label: 'Academic',
    icon: 'academicIcon',
    route: APP_ROUTES.ETL_DASHBOARD,
    privileges: [APP_FEATURES.INITIAL_SYSTEM_SETUP],
    isShown: true,
  },
  {
    label: 'Library',
    icon: 'libraryIcon',
    route: APP_ROUTES.ETL_DASHBOARD,
    privileges: [APP_FEATURES.INITIAL_SYSTEM_SETUP],
    isShown: true,
  },
  {
    label: 'Master Data',
    icon: 'MasterDataIcon',
    route: APP_ROUTES.ETL_DASHBOARD,
    privileges: [APP_FEATURES.INITIAL_SYSTEM_SETUP],
    isShown: true,
  },
];

export const SIDE_MENU_BOTTOM_ITEMS: ISideBarItem[] = [
  {
    /*
     * The signed-in person's own things — not "Profile", which described only
     * one of the rows and made the others look misfiled. My Leave is a
     * self-service action, not account data; grouping it under "Profile" was
     * the tell.
     *
     * It stays a group of its own rather than moving into Staff & Users,
     * because that group is gated on TEACHER_MANAGEMENT while My Leave is
     * gated on SELF_ATTENDANCE_LEAVE: filing it there would hide it from every
     * teacher, who is exactly who needs it. Staff & Users keeps the ADMIN side
     * of the same feature (Staff Leaves, Teacher Attendance).
     */
    label: 'My Space',
    icon: 'pi pi-user',
    route: '',
    isShown: true,
    children: [
      {
        // CVA-3753: personal details + Settings (2FA). No `privileges` —
        // every authenticated user reaches their own profile.
        label: 'My Profile',
        route: APP_ROUTES.MY_PROFILE,
        isShown: true,
      },
      {
        // The reader's own leave — balances, history and applying. Self-service,
        // so it sits here rather than in a management group. Admins see it too:
        // they take leave like everyone else, and approve other people's from
        // Staff & Users → Staff Leaves.
        label: 'My Leave',
        route: APP_ROUTES.MY_LEAVE,
        privileges: [APP_FEATURES.SELF_ATTENDANCE_LEAVE],
        isShown: true,
        subscriptionFeature: 'has_teacher_attendance',
      },
    ],
  },
];
